export default __webpack_public_path__ + "static/0295-e15288201e3c8d18ada454b7b7af2ab4.png";